export default "__VITE_ASSET__qcCueIB$__"